export default {"src":"/_next/static/media/firmware-libraries.1d24693c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};